module.exports = __webpack_public_path__ + "static/media/IMG_1567.473b0e56.jpg";